import { Box } from "@chakra-ui/react";
import React, { ReactNode } from "react";

interface BackgroundImagePageProps {
  children: ReactNode;
}

export const BackgroundImagePage: React.FC<BackgroundImagePageProps> = ({ children }) => {
  return (
    <Box
      position="relative"
      minH="100vh"
      w="full"
      bg="white"
      _after={{
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        bgGradient: 'linear(to-b, blue.100 0%, white 45%, whiteAlpha.950 100%)',
        zIndex: -1,
      }}
    >
      {children}
    </Box>
  );
};
